import { get, values } from 'lodash'

export const getVenues = (state) => values(get(state, ['venues', 'byId']))

export const getIsVenuesLoading = (state) => get(state, ['venues', 'isLoading'])

export const getCurrentVenueId = (state) => get(state, ['venues', 'selectedId'])

export const getCurrentVenue = (state) =>
  get(state, ['venues', 'byId', getCurrentVenueId(state)], {})
